export function obfuscate(input) {
  if (!input) return '';
  return `${input.substr(0, 4)}...${input.substr(input.length - 4)}`;
}

export default {obfuscate};
